/** Generates a random int between min and max, considering min as included and max as excluded */
export function randomIntBetween(min: number, max: number) {
    return Math.floor(Math.random() * max + min);
}
